import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Download } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { fetchOrders } from '../api/client';
import { useStore } from '../context/StoreContext';
import { useLocale } from '../context/LocaleContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useStore();
  const { t, formatPrice } = useLocale();

  useEffect(() => {
    (async () => {
      try {
        const data = await fetchOrders();
        setOrders(data.items || []);
      } catch (err) { console.warn('orders fetch', err.message); }
      finally { setLoading(false); }
    })();
  }, [user]);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="max-w-5xl mx-auto px-4 md:px-8 py-8">
        <h1 className="text-2xl md:text-3xl font-black">MY ORDERS</h1>
        <div className="h-1 w-14 bg-[#22c55e] mt-2 mb-6"></div>

        {loading ? (
          <div className="text-center py-16 text-gray-500">Loading your orders...</div>
        ) : orders.length === 0 ? (
          <div className="text-center py-16 border-2 border-dashed border-gray-200 rounded">
            <p className="text-gray-600">No orders yet.</p>
            <Link to="/" className="inline-block mt-4 bg-[#22c55e] text-white px-6 py-2 font-bold tracking-wider text-sm hover:bg-[#16a34a] transition">START SHOPPING</Link>
          </div>
        ) : (
          <div className="space-y-4">
            {orders.map((o) => (
              <div key={o.order_id} className="border rounded p-4">
                <div className="flex flex-wrap items-center justify-between gap-3">
                  <div>
                    <div className="text-xs text-gray-500">Order ID</div>
                    <div className="font-mono text-sm">{o.order_id.slice(0, 8)}...</div>
                  </div>
                  <div>
                    <div className="text-xs text-gray-500">Placed on</div>
                    <div className="text-sm">{new Date(o.created_at).toLocaleString()}</div>
                  </div>
                  <div>
                    <div className="text-xs text-gray-500">Total</div>
                    <div className="font-bold">{o.currency === 'EUR' ? '€' : '₹'}{Number(o.total).toFixed(2)}</div>
                  </div>
                  <div>
                    <span className="inline-block px-3 py-1 rounded-full bg-green-100 text-green-700 text-[11px] font-bold uppercase">{o.status}</span>
                  </div>
                  <a
                    href={`${BACKEND_URL}/api/orders/${o.order_id}/invoice`}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`my-order-invoice-${o.order_id.slice(0, 8)}`}
                    className="inline-flex items-center gap-1 bg-[#22c55e] hover:bg-[#16a34a] text-black font-bold text-[11px] tracking-wider px-3 py-1.5 rounded transition"
                  >
                    <Download size={12} /> INVOICE
                  </a>
                </div>
                <div className="mt-3 flex gap-2 overflow-x-auto">
                  {o.items.slice(0, 6).map((it, i) => (
                    <img key={`${it.productId || it.name || 'item'}-${i}`} src={it.image} alt="" className="w-14 h-16 object-cover rounded shrink-0" />
                  ))}
                  {o.items.length > 6 && <span className="text-xs text-gray-500 self-center">+{o.items.length - 6}</span>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default MyOrders;
